export { default as PageWithMenu } from './PageWithMenu';
